import { SecureStorage } from '../common-services/SecureStorage.service';
import { Injectable } from '@angular/core';
import { CultureCodes, CurrencyCodes, CultureDateFormat, AppointmentStatus, AppointmentStatusName, WOStatus, WOStatusName, SecureStorageKey, SignalRHubMethod } from '../utils/enums';
import { CurrentLanguage } from '../common-services/current-language.service';
import { BehaviorSubject } from 'rxjs';
import * as signalR from '@microsoft/signalr';
import { BrandLogoModel } from '../business-entities/brand-logo-model';
import { CacheImageModel } from '../business-entities/document-model';
import { EnvSetting } from '../utils/env-setting';
@Injectable({
  providedIn: 'root'
})

export class GlobalSetting {
  cultureCode: string;

  public signalrConnection: BehaviorSubject<signalR.HubConnection>;
  public signalrConnectionTracker: BehaviorSubject<signalR.HubConnection>;
  public bookingWidget: BehaviorSubject<any>;
  public isAuthenticated: BehaviorSubject<boolean>;
  public brandLogos: BrandLogoModel[] = [];
  public cacheImages: CacheImageModel[] = [];
  public checkinData: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public warrantyDocumentSigned: BehaviorSubject<boolean>;

  private AppSettings: any[];

  constructor(private readonly secureStorage: SecureStorage, 
    private readonly currentLanguage: CurrentLanguage) {
    this.currentLanguage.cultureCodeSubject.subscribe(x => {
      if (x === null || x === '') {
        this.cultureCode = this.secureStorage.getKeyData('CultureCode')
      }
      else {
        this.cultureCode = x
      }
    });
    this.signalrConnection = new BehaviorSubject<signalR.HubConnection>(null);
    this.signalrConnectionTracker = new BehaviorSubject<signalR.HubConnection>(null);
    this.bookingWidget = new BehaviorSubject<any>(null);
    this.isAuthenticated = new BehaviorSubject<any>(false);
    this.warrantyDocumentSigned = new BehaviorSubject<any>(false);
  }
  getCurrencyCode(cultureCode: string): string {
    let code = '';
    switch (cultureCode) {
      case CultureCodes.EN_US:
        code = CurrencyCodes.USD;
        break;
      case CultureCodes.NL_NL:
        code = CurrencyCodes.EUR;
        break;
      case CultureCodes.NB_NO:
        code = CurrencyCodes.NOK;
        break;
      case CultureCodes.FI_FI:
        code = CurrencyCodes.EUR;
        break;
      case CultureCodes.DE_DE:
        code = CurrencyCodes.EUR;
        break;
      default:
        code = CurrencyCodes.USD;
    }
    return code;
  }
  getFormattedprice(price: string): string {
    switch (this.cultureCode) {
      case CultureCodes.EN_US:
        price = price.replace(',', '');
        break;
      case CultureCodes.NL_NL:
        price = price.replace('.', '').replace(',', '.');
        break;
      case CultureCodes.NB_NO:
        price = price.replace(',', '.').replace(/\s/g, "");
        break;
      case CultureCodes.FI_FI:
        price = price.replace(',', '.').replace(/\s/g, "");
        break;
      case CultureCodes.DE_DE:
        price = price.replace('.', '').replace(',', '.');
        break;
      default:
        price = price.replace(',', '');
    }
    return price;
  }

  getDateFormat(): string {
    let format = '';
    switch (this.cultureCode) {
      case CultureCodes.EN_US:
        format = CultureDateFormat.EN_US;
        break;
      case CultureCodes.NL_NL:
        format = CultureDateFormat.NL_NL;
        break;
      case CultureCodes.NB_NO:
        format = CultureDateFormat.NB_NO;
        break;
      case CultureCodes.FI_FI:
        format = CultureDateFormat.FI_FI;
        break;
      case CultureCodes.DE_DE:
        format = CultureDateFormat.DE_DE;
        break;
      default:
        format = CultureDateFormat.EN_US;
    }
    return format;
  }
  getAppointmentStatusName(status): string {
    let AppointmentStatusname: string;
    switch (status) {
      case AppointmentStatus.Confirmed:
        AppointmentStatusname = AppointmentStatusName.Confirmed;
        break;
      case AppointmentStatus.CheckedIn:
        AppointmentStatusname = AppointmentStatusName.CheckedIn;
        break;
      case AppointmentStatus.Completed:
        AppointmentStatusname = AppointmentStatusName.Completed;
        break;
      case AppointmentStatus.Cancelled:
        AppointmentStatusname = AppointmentStatusName.Cancelled;
        break;
      case AppointmentStatus.Pending:
        AppointmentStatusname = AppointmentStatusName.Pending;
        break;
      case AppointmentStatus.InProgress:
        AppointmentStatusname = AppointmentStatusName.InProgress;
        break;
      case AppointmentStatus.CarArrived:
        AppointmentStatusname = AppointmentStatusName.CarArrived;
        break;
      case AppointmentStatus.WorkStarted:
        AppointmentStatusname = AppointmentStatusName.WorkStarted;
        break;
      case AppointmentStatus.InvoiceReady:
        AppointmentStatusname = AppointmentStatusName.InvoiceReady;
        break;
      case AppointmentStatus.Closed:
        AppointmentStatusname = AppointmentStatusName.Closed;
        break;
      default:
        AppointmentStatusname = null;
    }
    return AppointmentStatusname;
  }
  getWorkOrderStatus(status: number): string {
    let WOstatus: string = '';
    switch (status) {
      case WOStatus.Waitingforcustomer:
        WOstatus = WOStatusName.Waitingforcustomer;
        break;
      case WOStatus.Cararrived:
        WOstatus = WOStatusName.Cararrived;
        break;
      case WOStatus.Mechanicstarted:
        WOstatus = WOStatusName.Mechanicstarted;
        break;
      case WOStatus.Checklistrecorded:
        WOstatus = WOStatusName.Checklistrecorded;
        break;
      case WOStatus.Mechanicdone:
        WOstatus = WOStatusName.Mechanicdone;
        break;
      case WOStatus.Workdone:
        WOstatus = WOStatusName.Workdone;
        break;
      case WOStatus.Invoiceready:
        WOstatus = WOStatusName.Invoiceready;
        break;
      case WOStatus.WorkRequest:
        WOstatus = WOStatusName.WorkRequest;
        break;
      case WOStatus.InvoicePaid:
        WOstatus = WOStatusName.InvoicePaid;
        break;
      case WOStatus.Closed:
        WOstatus = WOStatusName.Closed;
        break;
      case WOStatus.Cancelled:
        WOstatus = WOStatusName.Cancelled;
        break;
      case WOStatus.Prepared:
        WOstatus = WOStatusName.Prepared;
        break;
      default:
        WOstatus = null;
    }
    return WOstatus;
  }

  getGlobalLicencePlate(): any {
    if (this.secureStorage.getKeyData('LicencePlateClass')) {
      let LicencePlateClass = this.secureStorage.getKeyData('LicencePlateClass');
      if (LicencePlateClass) {
        return LicencePlateClass;
      }
      else {
        return null;
      }
    };
    return null;
  }
  getGlobalLogoUrlLink(): any {
    if (this.secureStorage.getKeyData('LogoUrlLink')) {
      let LogoUrlLink = this.secureStorage.getKeyData('LogoUrlLink');
      if (LogoUrlLink) {
        return LogoUrlLink;
      }
      else {
        return null;
      }
    };
    return null;
  }
  getGlobalWidgetLogoUrlLink(): any {
    if (this.secureStorage.getKeyData('WidgetLogoUrlLink')) {
      let WidgetLogoUrlLink = this.secureStorage.getKeyData('WidgetLogoUrlLink');
      if (WidgetLogoUrlLink) {
        return WidgetLogoUrlLink;
      }
      else {
        return null;
      }
    };
    return null;
  }
  //#region Edit Appointment Lock/Unlock
  InitEditByOtherConfig(appointment) {
    if (appointment?.id > 0) {
      this.signalrConnection.subscribe(
        (connection) => {
          if (connection) {
            const userData = this.secureStorage.getKeyData(SecureStorageKey.GetUserDetails);
            let model = {
              UserName: userData.name,
              AppointmentGuid: appointment.appointmentGuid,
              WorkOrderNo: appointment.workOrderNo,
              LockConnectionId: appointment.id.toString(),
              LockConnectionToken: connection.connectionId,
              LockedBy: userData.userId
            }
            if (connection.state === signalR.HubConnectionState.Connected) {
              connection.invoke(SignalRHubMethod.AddAppointmentLock, model).then(function () {
                // This is intentional
              });
            } 
          }
        }
      ).unsubscribe();
    }
  }
  RemoveEditByOtherConfig(appointment) {
    if (appointment?.id > 0) {
      this.signalrConnection.subscribe(
        (connection) => {
          if (connection) {
            const userData = this.secureStorage.getKeyData(SecureStorageKey.GetUserDetails);
            let model = {
              Id: 0,
              UserName: userData.name,
              LockConnectionId: appointment.id.toString(),
              UnlockedBy: userData.userId,
              LockConnectionToken: connection.connectionId,
              LockedBy: userData.userId,
              AppointmentId: appointment.id,
              AppointmentGuid: appointment.appointmentGuid
            }
            connection.invoke(SignalRHubMethod.UnlockAppointmentLock, model).then(function () {
              // This is intentional
            });
          }
        }
      ).unsubscribe();
    }
  }
  //#endregion

  //#region App Setting
  MapAppSetting(settings) {
    this.AppSettings = settings;
    EnvSetting.colorCode = this.getString('colorCode');
    EnvSetting.LANGUAGE_CONFIG.defaultLanguage = this.getString('LANGUAGE_CONFIG.defaultLanguage');
    EnvSetting.LANGUAGE_CONFIG.defaultLanguageText = this.getString('LANGUAGE_CONFIG.defaultLanguageText');
    EnvSetting.LANGUAGE_CONFIG.defaultLanguageFlag = this.getString('LANGUAGE_CONFIG.defaultLanguageFlag');
    EnvSetting.language.LanguageOverRule = this.getBoolean('language.LanguageOverRule');
    EnvSetting.language.LanguageOverRuleDefault = this.getString('language.LanguageOverRuleDefault');

    EnvSetting.NOTIFICATION_API_BASE_URL = this.getString('NOTIFICATION_API_BASE_URL');
    EnvSetting.SMS_API_BASE_URL = this.getString('SMS_API_BASE_URL');
    EnvSetting.ADMIN_BASE_API_URL = this.getString('ADMIN_BASE_API_URL');
    EnvSetting.CAMPAIGN_BASE_API_URL = this.getString('CAMPAIGN_BASE_API_URL');
    EnvSetting.WIDGET_API_URI = this.getString('WIDGET_API_URI');
    EnvSetting.CHECKIN_BASE_API_URL = this.getString('CHECKIN_BASE_API_URL');
    EnvSetting.STATUS_TRACKER_BASE_API_URL = this.getString('STATUS_TRACKER_BASE_API_URL');
    EnvSetting.googleMapUrl = this.getString('googleMapUrl');
    EnvSetting.googleKey = this.getString('googleKey');
    EnvSetting.STATUSTRACKER_DEFAULT_LANGUAGE_CONFIG = this.getString('STATUSTRACKER_DEFAULT_LANGUAGE_CONFIG');
    EnvSetting.CHECKIN_DEFAULT_LANGUAGE_CONFIG = this.getString('CHECKIN_DEFAULT_LANGUAGE_CONFIG');
    EnvSetting.GOOGLE_API_KEY = this.getString('GOOGLE_API_KEY');
    EnvSetting.otpExpireTime = this.getString('otpExpireTime');
    EnvSetting.currentenvironment = this.getString('currentenvironment');
    EnvSetting.vehicleOwnerSource = this.getString('vehicleOwnerSource');
    EnvSetting.CultureFormat = this.getString('CultureFormat');
    EnvSetting.parts_service_url = this.getString('parts_service_url');
    EnvSetting.PUSH_NOTIFICATION_API_URI = this.getString('PUSH_NOTIFICATION_API_URI');
    EnvSetting.ShiftTime = this.getString('ShiftTime');
    EnvSetting.MinimunTimeSlot = this.getString('MinimunTimeSlot');
    EnvSetting.FuturePlanningTime = this.getString('FuturePlanningTime');
    EnvSetting.EnableCookieConsent = this.getBoolean('EnableCookieConsent');
    EnvSetting.Tracker_CookieScript_Key = this.getString('Tracker_CookieScript_Key');
    EnvSetting.Widget_CookieScript_Key = this.getString('Widget_CookieScript_Key');
    EnvSetting.CheckIn_CookieScript_Key = this.getString('CheckIn_CookieScript_Key');
    EnvSetting.IsActiveTodayBooking = this.getString('IsActiveTodayBooking');
    EnvSetting.Country = this.getString('Country');
    EnvSetting.ThirdPartyVehicleSource = this.getString('ThirdPartyVehicleSource');
    EnvSetting.WidgetContacUsLink = this.getString('WidgetContacUsLink');
    EnvSetting.StatusTrackerInterval = this.getString('StatusTrackerInterval');
    EnvSetting.SlotExpireMinutes = this.getString('SlotExpireMinutes');
    EnvSetting.WhatsAppNotificationRefreshInterval = this.getString('WhatsAppNotificationRefreshInterval');
    EnvSetting.whatsappContactNo = this.getString('whatsappContactNo');
    EnvSetting.PlanningFromTime = this.getString('PlanningFromTime');
    EnvSetting.PlanningToTime = this.getString('PlanningToTime');
  }
  private getString(key: string): string {
    let val = this.AppSettings.find(x => x.property == key)?.value ?? ''
    return val;
  }
  private getBoolean(key: string): boolean {
    let val = this.AppSettings.find(x => x.property == key)?.value ?? 'false'
    return JSON.parse(val);
  }
  //#endregion
}


